<template>
    <section id="classPage" class="class-page" style="padding:15px;">
       	<class-page-header :details="details" :current-section="parseInt(sectionId)" :course="course" :menu="menu" :is-class-item-page="true"></class-page-header>
        <div class="class-page-body" v-if="!!LTI.report_name">
			<h2>{{LTI.report_name}}</h2>

            <div v-if="LTI.displaySetting === 'iframe' && !LTI.debug">
                <vue-friendly-iframe class="viewport" className="LTI"
                    :src="LTI.launchURL"
                    ref="LTI"
                    style="width:80vw;height:80vh;border:none;"
                    @load="setData">
				</vue-friendly-iframe>
            </div>
            <div v-else>
                <form id="auto_submit" :action="LTI.authURL" method="GET" ref="LTIForm">
                    <input name="iss" v-model="LTI.iss" type="hidden"/>
                    <input name="target_link_uri" v-model="LTI.target_link_uri" type="hidden"/>
                    <input name="login_hint" v-model="LTI.login_hint" type="hidden"/>
                    <input name="lti_message_hint" v-model="LTI.lti_message_hint" type="hidden"/>
                </form>
                <div v-if="!!LTI.debug">
                    {{LTI.launchURL}}<br/>
                    {{LTI.login_hint}}<br/>
                    {{LTI.lti_message_hint}}<br/>
                    <button type="button" onclick="document.getElementById('auto_submit').submit();">
											{{ $t( 'MAIN_CONTENT.LTILaunch.go' ) }}
                    </button>
                </div>
            </div>
        </div>

        <class-page-footer :course="course" :menu="menu" :current-section="parseInt(sectionId)" :is-class-item-page="true"/>
    </section>
</template>
<script>

import { mapGetters } from "vuex";
import ClassPageHeader from "./Header.vue";
import ClassPageFooter from "./Footer.vue";
import VueFriendlyIframe from 'vue-friendly-iframe';
import ClassPageDetailsResource from '../../api/ClassPageDetails';
import ClassPageMenuResource from '../../api/ClassPageMenu';
import ClassPageSectionResource from '../../api/ClassPageSection';
import LTILaunchResource from '../../api/LTILaunch';
import CoursesResource from '../../api/Courses';

export default {
	components: {
			ClassPageHeader,
            ClassPageFooter,
            VueFriendlyIframe
	},
	props: {
		section: { 
				type    : Number,
				default : 0
		},
	},
	data() {
		return {
			sectionData: {},
			menu: [],
			details: {},
			course: {},
			LTI: {},
		};
	},
	computed: {
		...mapGetters(['selectedStudent', 'roleRules']),
		sectionId() {
			return this.$route.params.folderId ? this.$route.params.folderId : 0;
		}
	},
	created() {
		this.$store.commit('setUseHeader', false);
		this.fetchMenu();
		this.fetchDetails();
        this.fetchCourse();
        this.fetchLTIInfo();
		
    },
	methods: {
		fetchLTIInfo() {
			let type = '';
			if( this.$route.name === 'ClassPageLTILaunch' ){
				type = 'C';
			} else if ( this.$route.name === 'ClassPageGroupLTILaunch' ) {
				type = 'G';
			} else if ( this.$route.name === 'ClassPageStudentLTILaunch' ) {
				type = 'S';
			}
			const LTILaunch = new LTILaunchResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
                    line_no: this.$route.params.lineNo,
                    line_no_type: type
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				}
			});

			LTILaunch.get().then((response) => {
                this.LTI = response.data;
                this.$nextTick(function () {
                    this.submitForm();
                });
			});
        },
        submitForm(){
            this.$refs.LTIForm.submit();
        },
		fetchSection(){
			const ClassPageSection = new ClassPageSectionResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
					folderId: this.$route.params.folderId,
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				}
			});

			ClassPageSection.get().then(() => {
				this.sectionData = ClassPageSection.getResponseData();
			});
		},
		fetchMenu(){
			const ClassPageMenu = new ClassPageMenuResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				},
			});

			ClassPageMenu.get().then(()=>{
				this.menu = ClassPageMenu.getResponseData();
			});
		},
		fetchDetails(){
			const ClassPageDetails = new ClassPageDetailsResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				},
			});

			ClassPageDetails.get().then(()=>{
				this.details = ClassPageDetails.getResponseData();
			});
		},
		fetchCourse(){
			const Course = new CoursesResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				},
			});

			Course.get().then(()=>{
				this.course = Course.getResponseData();
			});
		}
    }
};
</script>
